export default __webpack_public_path__ + "static/rocketlink-d720c073356705513c5b605ae281f1fa.svg";